import roundAccountBox from '@iconify/icons-ic/round-account-box';
import roundVpnKey from '@iconify/icons-ic/round-vpn-key';
import { Icon } from '@iconify/react';
import { Box, Stack, Dialog, DialogActions, DialogTitle, DialogContentText, DialogContent, Divider, Container } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// material

import useAuth from 'src/hooks/useAuth';
import { Button } from 'src/@/components/ui/button';

import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from "src/@/components/ui/tabs"

import HorariosAtendimento from './HorariosAtendimento';
import v2_actionBuscarDadosCliente from 'src/actions/v2/cliente/v2_actionBuscarDadosCliente';
import v2_actionEditarCliente from 'src/actions/v2/cliente/v2_actionEditarCliente';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import v2_actionCaledarioDetalhes from 'src/actions/v2/calendario/v2_actionCaledarioDetalhes';

//components
import Iconify from 'src/components/Iconify';
import { Input } from 'src/@/components/ui/input';
import { RadioButtonList } from 'src/@/components/shared/RadioButtonList';
import v2_actionEditarCalendario from 'src/actions/v2/calendario/v2_actionEditarCalendario';
import GoogleLogin from '../Integracoes/components/GoogleLogin';

export default function CalendarioConfig() {
    const { logout, user, cliente } = useAuth();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const [config, setConfig] = useState(null);
    const [name, setName] = useState('');
    const [source, setSource] = useState('');
    const [loading, setLoading] = useState(false);

    const location = useLocation();
    // Extrai o parâmetro de consulta "channel" da string de busca (search) da URL
    const params = new URLSearchParams(location.search);
    const calendarId = params.get('id');


    async function handleEdit() {
        try {
            let data = {
                scope: {
                    name:name,
                    source: source,
                    config: config,
                }
            }
            setLoading(true);
            await v2_actionEditarCalendario(calendarId, data)
            setLoading(false);
            enqueueSnackbar('Editado com sucesso', { variant: 'success' });
            buscarConfiguracoes();
        } catch (error) {
            console.log('error', error)
            enqueueSnackbar('Erro ao editar', { variant: 'error' });
        }
    }

    async function buscarConfiguracoes() {
        try {
            const response = await v2_actionCaledarioDetalhes(calendarId);
            console.log('response', response.data.data)
            setSource(response.data.data.source)
            setName(response.data.data.name)
            setConfig(response.data.data.config)
        } catch (error) {
            console.log('error', error)
        }
    }



    useEffect(() => {
        buscarConfiguracoes()
        if(!calendarId){
            navigate('/dashboard/configuracoes/calendarios')
        }
    }, [])


    return (
        <Container>


            <div className="flex flex-row justify-between">
                <div className="flex flex-row justify-between gap-2">
                    <Button
                        size='icon'
                        variant='outline'
                        onClick={
                            () => {
                                navigate('/dashboard/configuracoes/calendarios')
                            }}
                    >
                        <Iconify icon="majesticons:arrow-left" color="black" />

                    </Button>
                    <Input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Nome do calendário"
                    />
                </div>

                <ButtonLoading
                    loading={false}
                    onClick={handleEdit}
                >
                    Salvar
                </ButtonLoading>

            </div>

            <div className='mt-8'>
                <h2 className="text-md font-bold mb-1">Fonte</h2>

                <RadioButtonList
                    title="Fonte"
                    selected={source}
                    disabled={true}
                    options={[
                        {
                            value: 'lais',
                            label: 'Lais',
                            // icon: 'ic:round-account-box',
                        },
                        {
                            value: 'google',
                            label: 'Google calendário',
                            // icon: 'ic:round-vpn-key',
                        },
                    ]}
                    onChange={(value) => setSource(value)}
                />
            </div>

            {
                source === 'google' &&
                <div className='mt-8'>
                    <h2 className="text-md font-bold mb-1">Configuracoes do google</h2>

                    <GoogleLogin />
                </div>
            }

            <Divider className='border-dashed mt-4' />

            <div className='flex flex-col gap-2 mt-8'>
                <HorariosAtendimento
                    config={config}
                    changeConfig={setConfig}
                />
            </div>

            <div className='mt-8'>
                <ButtonLoading
                    loading={loading}
                    onClick={handleEdit}
                >
                    Salvar
                </ButtonLoading>
            </div>

        </Container>
    );
}
